import { Component, OnInit } from '@angular/core';
import {FormEntityExtension} from '../../../resources/extensions/form-entity-extension/form-entity.extension';
import {FormEntityExtensionService} from '../../../resources/extensions/form-entity-extension/form-entity-extension.service';
import {FormBuilder, Validators} from '@angular/forms';

@Component({
  selector: 'custom-data-form',
  templateUrl: './custom-data-form.component.html',
})
export class CustomDataFormComponent extends FormEntityExtension implements OnInit {

  code: string = '';
  editorOptions: any = {theme: 'vs-dark', language: 'json'};

  constructor(protected formEntityExtensionService: FormEntityExtensionService) {
    super(formEntityExtensionService);
  }

  ngOnInit(): void {
    this.initForm(
      new FormBuilder().group({
        key: ['', Validators.required],
        store: [null, Validators.required],
        json: ['', Validators.required],
      })
    );
  }



}
